export const SET_NOME = 'contato/SET_NOME';
export const SET_EMAIL = 'contato/SET_EMAIL';
export const SET_MENSAGEM = 'contato/SET_MENSAGEM';
export const ENVIAR_CONTATO_REQUEST = 'contato/ENVIAR_CONTATO_REQUEST';
export const ENVIAR_CONTATO_SUCCESS = 'contato/ENVIAR_CONTATO_SUCCESS';
export const ENVIAR_CONTATO_ERROR = 'contato/ENVIAR_CONTATO_ERROR';
export const DISPENSAR_NOTIFICACAO_DE_SUCESSO = 'contato/DISPENSAR_NOTIFICACAO_DE_SUCESSO';
export const EXIBE_CHAT = 'contato/EXIBE_CHAT'
